<div class="container pt-3">
  <div><span style="font-size: 14px;">SCL Dashboard Powered Secure Choice Lending &reg;</span></div>
</div>
<nav class="navbar main-navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow">
  <div class="container justify-content-center">
    <!--<a class="navbar-brand" [routerLink]="['/']">
    <img src="/assets/images/logo-default.svg" alt="Secure Choice Lending" class="logo-img">
  </a>-->
    <button class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target=".navbar-collapse"
            aria-label="Toggle navigation"
            [attr.aria-expanded]="isExpanded"
            (click)="toggle()">
      <span class="navbar-toggler-icon"></span>
    </button>
    <ul class="navbar-nav flex-grow align-items-md-center main-menu ml-auto">
      <li app-main-nav-menu [menuItems]="menu()?.mainMenuItems || []"></li>
    </ul>
    <ul class="navbar-nav flex-grow align-items-md-center">
      <li class="navbar-nav-item">
        <app-profile-nav-menu></app-profile-nav-menu>
      </li>
    </ul>
  </div>
</nav>
<app-second-nav-menu [menuItems]="menu()?.secondMenuItems || []"></app-second-nav-menu>
